import ApolloClient from "apollo-boost";
import store from "./configureStore";
import { jwtExpiredOrInvalid } from "../store/actions/JWTActions";

const client = new ApolloClient({
  uri: window.env.HasuraURL,
  request: operation => {
    operation.setContext({
      headers: {
        authorization: `Bearer ${store.getState().jwt.jwt_token}`
      }
    });
  },
  onError: ({operation, networkError}) => {
    if (networkError !== "TypeError: Failed to fetch") {
      // store.dispatch(jwtExpiredOrInvalid(true));
    }
  }
});

client.defaultOptions = {
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all"
  }
};

export default client;



// WEBPACK FOOTER //
// ./src/store/apolloClient.js